




































































































































































































































































































import { Vue, Component, Ref } from 'vue-property-decorator';
import orgPic from 'assets/homepage/carousel/org.png';
import proPic from 'assets/homepage/carousel/product.png';
import reqPic from 'assets/homepage/carousel/require.png';
import knowPic from 'assets/homepage/carousel/know.png';
import p1 from 'assets/homepage/know/p1.png';
import p2 from 'assets/homepage/know/p2.png';
import p3 from 'assets/homepage/know/p3.png';
import p4 from 'assets/homepage/know/p4.png';
import p5 from 'assets/homepage/know/p5.png';
import p6 from 'assets/homepage/know/p6.png';
import p7 from 'assets/homepage/know/p7.png';
import p8 from 'assets/homepage/know/p8.png';
import {
  getKnowledgeList,
  getNewsList, getOrganizationList, getProductList, getRankList, getRequireTypes, searchRequire,
} from 'service/api';
import NavigationCardHome from '@/NavigationCardHome';
import { Carousel } from 'element-ui';
import {
  IndustryList,
  LocalIndustryItem, LocalNewsItem,
  LocalProductItem,
  LocalRankItem, NewsList,
  ProductList,
  RankList, RequireList, LocalRequireItem, KnowList, LocalKnowItem,
} from 'src/types/views/home';
import { TypeItem, TypeList } from 'src/types/views/common';

  @Component({
    components: { NavigationCardHome },
  })
export default class Home extends Vue {
    bannerCarousel = [
      {
        name: 'serviceOrg',
        url: orgPic,
        icon: 'organization',
      },
      {
        name: 'serviceProduct',
        url: proPic,
        icon: 'product',
      },
      {
        name: 'serviceRequire',
        url: reqPic,
        icon: 'require',
      },
      {
        name: 'knowledge',
        url: knowPic,
        icon: 'knowledge',
      },
    ];

    knowledgePlaceholder = [p1, p2, p3, p4, p5, p6, p7, p8];

    activeCarouselName = 'serviceOrg';

    productList: LocalProductItem[] = [];

    rankList: LocalRankItem[] = [];

    newsList: LocalNewsItem[] = [];

    currNewsTitle = '新闻正在加载中...';

    orgList: LocalIndustryItem[] = [];

    requireTypeList: TypeItem[] = [];

    currRequireType = '';

    requireList: LocalRequireItem[] = [];

    knowledgeList: LocalKnowItem[] = [];

    keyword = '';

    searchType = 'serviceOrg';

    wholews = '0';

    @Ref('carousel') readonly carousel!: Carousel;

    bindCarouselChange(index: number) {
      this.activeCarouselName = this.bannerCarousel[index].name;
    }

    changeNewsTitle(index: number) {
      this.currNewsTitle = this.newsList[index].title;
    }

    changeCarousel(name: number) {
      this.carousel.setActiveItem(name);
    }

    changeRequireType(type: string) {
      this.currRequireType = type;
      this.getRequireList();
    }

    clickReqRow(row: { id: string }) {
      this.toDetail('requireDetail', row.id);
    }

    toDetail(name: string, id: string) {
      this.$router.push({
        name,
        query: { id },
      });
    }

    async requestProductList() {
      const res = await getProductList({
        pageNum: 1,
        pageSize: 8,
        wholews: 0,
      });
      if ((res as ProductList).code === 200) {
        this.productList = (res as ProductList).data.rows.map((item) => {
          const productType = item.productType !== '0'
            ? item.producttypename.replace(/[(（].*?[)）]/g, '')
            : '综合';
          const subTypeName = item.producttypename.match(/[(（].*?[)）]/g);
          const subProductType = subTypeName
            ? subTypeName
              .map((name: string) => name.replace(/[()（）]/g, '').split(/[,，]/))
              .reduce((prev: string[], cur: string[]) => prev.concat(cur), [])
              .sort((a: string, b: string) => a.length - b.length)
            : ['全部'];
          return {
            name: item.name,
            type: productType,
            subType: subProductType.length > 4 ? subProductType.slice(0, 3).concat('...') : subProductType,
            area: item.serviceareaname,
            id: item.id,
            time: item.createTime,
          };
        });
      }
    }

    async getOrganizationList() {
      const res = await getOrganizationList({
        pageNum: 1,
        pageSize: 10,
        wholews: 0,
      });
      if ((res as IndustryList).code === 200) {
        this.orgList = (res as IndustryList).data.rows.map(item => ({
          name: item.name,
          area: item.serviceareaname,
          url: item.logo,
          industry: item.serviceindustryname.replace(/[(（].*?[)）]/g, '').split(/[,，]/).slice(0, 2),
          description: item.description.replace(/<[^>]+>|&nbsp;|\s+/g, ''),
          id: item.id,
        }));
      }
    }

    async getRankList() {
      const res = await getRankList({
        pageNum: 1,
        pageSize: 3,
      });
      if ((res as RankList).code === 200) {
        this.rankList = (res as RankList).data.rows.map(item => ({
          title: item.title,
          time: item.releaseTim.substr(0, 10),
          id: item.id,
        }));
      }
    }

    async getNewsList() {
      const res = await getNewsList();
      if ((res as NewsList).code === 200) {
        this.newsList = (res as NewsList).data.rows.map(item => ({
          title: item.title,
          url: item.img_url,
          id: item.id,
        }));
        this.currNewsTitle = (res as NewsList).data.rows[0].title;
      }
    }

    async getRequireTypeList() {
      const res = await getRequireTypes({
        fatherid: 1807,
      });
      if ((res as TypeList).code === 200) {
        this.requireTypeList = [{ name: '全部', id: '' }].concat((res as TypeList).data.rows.slice(0, 14).map(item => ({
          name: item.name,
          id: item.id,
        })));
        this.currRequireType = '';
      }
    }

    async getRequireList() {
      const res = await searchRequire({
        word: '',
        pageNum: 1,
        pageSize: 9,
        requiredonetype: this.currRequireType,
        requiredtwotype: '',
        start: 0,
        end: 0,
        money: 0,
        lowprice: 0,
        highprice: 100000000,
        deadTime: 0,
        province: -1,
        city: -1,
        downtown: -1,
        sameCity: 0,
        wholews: 0,
      });
      if ((res as RequireList).code === 200) {
        this.requireList = (res as RequireList).data.rows.map(item => ({
          id: item.id,
          name: item.name,
          remainDays: item.deadTime,
          price: item.price,
          address: item.requiredareaname,
          industry: item.requiredindustryname,
          description: item.description.replace(/<[^>]+>|&nbsp;|\s+/g, ''),
        }));
      }
    }

    async getKnowList() {
      const res = await getKnowledgeList({
        pageNum: 1,
        pageSize: 8,
        wholews: 0,
      });
      if ((res as KnowList).code === 200) {
        this.knowledgeList = (res as KnowList).data.rows.map((item, index) => ({
          name: item.title,
          url: item.imgurl || this.knowledgePlaceholder[index],
          time: item.releaseTime,
          organization: item.releaseOrganization,
          id: item.id,
        }));
      }
    }

    mounted() {
      this.requestProductList();
      this.getRankList();
      this.getNewsList();
      this.getOrganizationList();
      this.getRequireTypeList().then(() => {
        this.getRequireList();
      });
      this.getKnowList();
    }
}
